function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { withAbTests } from "contexts/ab-tests-context";
import { updateClusterFooterLinks } from "client/services/cluster-config-service/cluster-config-service";
import ShortFooter from "components/core/short-footer/short-footer";
import DefaultProps from "./default-props";
import FooterCategoryComponent from "./footer-category/footer-category-component";
import { StyledDesktopFooterContainer, StyledMobileFooterContainer, StyledFooter } from "./long-footer.scss";
import { SocialFooterLinks } from "/constants/links";
import FooterBottomBarComponent from "./footer-bottom-bar/footer-bottom-bar-component";
import { getFooterComponents } from "/services/localization/localization-service";
import { useEffect } from "react";
const Footer = (props)=>{
    const { translate, localeId, abTests, pageClusterConfig, useProductMiniSiteConfig, setStartShowingStickyHeader, isInView } = props;
    useEffect(()=>{
        setStartShowingStickyHeader(!isInView);
    }, [
        isInView,
        setStartShowingStickyHeader
    ]);
    const LONG_FOOTER = "long";
    const renderShortFooter = ()=>{
        return /*#__PURE__*/ _jsx(ShortFooter, _object_spread({}, props));
    };
    const renderLongFooter = ()=>{
        const getFullFooterForLocalized = true;
        const footerComponents = getFooterComponents(localeId, abTests, getFullFooterForLocalized, {});
        if (pageClusterConfig) {
            updateClusterFooterLinks(pageClusterConfig, footerComponents, {
                useProductMiniSiteConfig
            });
        }
        const { MondayFooterLinks, OurTeamFooterLinksV2, MoreByMondayFooterLinks, UseCasesFooterLinksV2, ResourcesFooterLinks, ProductsFooterLinks, FeaturesFooterLinks } = footerComponents;
        return /*#__PURE__*/ _jsxs(StyledFooter, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ _jsx("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "categories-container",
                            children: [
                                MondayFooterLinks && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        title: translate(MondayFooterLinks.title),
                                        links: MondayFooterLinks.links,
                                        hasMondayLogoTitle: MondayFooterLinks.hasMondayLogoTitle
                                    })
                                }),
                                FeaturesFooterLinks && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        title: translate(FeaturesFooterLinks.title),
                                        links: FeaturesFooterLinks.links
                                    })
                                }),
                                ProductsFooterLinks && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                                type: ProductsFooterLinks.type,
                                                title: translate(ProductsFooterLinks.title),
                                                links: ProductsFooterLinks.links
                                            }),
                                            /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                                type: MoreByMondayFooterLinks.type,
                                                title: translate(MoreByMondayFooterLinks.title),
                                                links: MoreByMondayFooterLinks.links
                                            })
                                        ]
                                    })
                                }),
                                UseCasesFooterLinksV2 && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        title: translate(UseCasesFooterLinksV2.title),
                                        links: UseCasesFooterLinksV2.links
                                    })
                                }),
                                OurTeamFooterLinksV2 && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        type: OurTeamFooterLinksV2.type,
                                        title: translate(OurTeamFooterLinksV2.title),
                                        links: OurTeamFooterLinksV2.links
                                    })
                                }),
                                ResourcesFooterLinks && /*#__PURE__*/ _jsx("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        type: ResourcesFooterLinks.type,
                                        title: translate(ResourcesFooterLinks.title),
                                        links: ResourcesFooterLinks.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(FooterBottomBarComponent, {
                    SocialFooterLinks: SocialFooterLinks,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StyledDesktopFooterContainer, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ _jsx(StyledMobileFooterContainer, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
export default withAbTests(withGenericConfig(Footer));
Footer.defaultProps = DefaultProps;
